
























































































































import { Vue, Component, Watch } from "vue-property-decorator"
import { Route } from 'vue-router';

@Component({
})
export default class AboutBoccoChannel extends Vue {
}
